import React from "react";
import { LOGO_URL, MOTTO_LINES, contactInfo, navLinks, whatsappNumbers } from "../data/content";
export function Footer() {
  return <footer className="bg-ink text-paper" data-id="element-85" data-mp="3ggtxgg3gzf46">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8" data-id="element-86" data-mp="32o4b2ak1486j">
        <div className="grid gap-14 lg:grid-cols-[1.5fr_1fr_1fr]" data-id="element-87" data-mp="32pp4txyirn3c">
          <div data-id="element-88" data-mp="36qhf8uj4ny17">
            <div className="flex items-center gap-3" data-id="element-89" data-mp="36pzatambadi7">
              <img src={LOGO_URL} alt="" className="h-16 w-16 object-contain mix-blend-lighten" data-id="element-90" data-mp="3ufa7afwmplqj" />
              <span className="leading-tight" data-id="element-91" data-mp="38h456i9zcjd">
                <span className="block text-lg font-semibold tracking-wide" data-id="element-92" data-mp="387fbm8yvbf9">FORTIS</span>
                <span className="block text-xs tracking-[0.18em] text-gold" data-id="element-93" data-mp="3ldkeb5n3meqn">SPORTS MANAGEMENT</span>
              </span>
            </div>
            <p className="mt-8 max-w-sm italic leading-relaxed text-paper/75" data-id="element-94" data-mp="3qf9sgu5mb8iy">
              {MOTTO_LINES.map(line => <span key={line} className="block" data-id="element-95" data-mp="2eyt6sj3gzvnn">
                  {line}
                </span>)}
            </p>
          </div>

          <nav aria-label="Pie de página" data-id="element-96" data-mp="3la27gozaktsl">
            <h2 className="text-sm font-semibold text-gold" data-id="element-97" data-mp="3gapb9dmj6adc">Navegación</h2>
            <ul className="mt-5 space-y-3" data-id="element-98" data-mp="3gcjw6rxsy2hf">
              {navLinks.map(link => <li key={link.href} data-id="element-99" data-mp="3v91ans1afx87">
                  <a href={link.href} className="text-paper/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-100" data-mp="3q8wq9qx9eicp">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-101" data-mp="34gtn85h8b3d">
                <a href={contactInfo.transfermarktUrl} target="_blank" rel="noopener noreferrer" className="text-paper/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-102" data-mp="335szh7bvjgh">
                  Jugadores en Transfermarkt
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-103" data-mp="mspojpyemv6k">
            <h2 className="text-sm font-semibold text-gold" data-id="element-104" data-mp="mt7rf5fko7ng">Contacto</h2>
            <ul className="mt-5 space-y-3 text-paper/75" data-id="element-105" data-mp="tvmp5eeoaakb">
              {whatsappNumbers.map(number => <li key={number.url} data-id="element-106" data-mp="yteeq1ruhklc">
                  <a href={number.url} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-107" data-mp="yuhaoo40yd84">
                    WhatsApp: {number.display}
                  </a>
                </li>)}
              <li data-id="element-108" data-mp="1hjw90asbso8t">
                <a href={`mailto:${contactInfo.email}`} className="break-all transition-colors duration-150 ease-out hover:text-gold" data-id="element-109" data-mp="1hje12gwawll2">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-ink-line pt-8 text-sm text-paper/55" data-id="element-110" data-mp="3obeunkz0yy86">
          © {new Date().getFullYear()} Fortis Sports Management. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}